export const Automation = '/api/v1/automation'
